import React from 'react'

const WordCard = (props) => {
  return (
      <div className="col-sm-2" data-aos="fade-up">
        <a href={props.link} target="_blank">
           <div className={props.worknumber}>
              <div class="work">
                   <small class="project_type">{props.project_type}</small>
                   <h1 className="light-slate mb-3">{props.title}</h1>
                   <p>{props.text}</p>
                   <p class="lang">{props.language}</p>
              </div>
           </div>
        </a> 
      </div>
  )
}

export default WordCard;